import { NgModule } from '@angular/core';

import { DealershipSendSmsComponent } from './dealership.send-sms.component';
import { SharedModule }               from '../shared/shared.module';

@NgModule({
  declarations: [
    DealershipSendSmsComponent
  ],
  entryComponents: [
    DealershipSendSmsComponent
  ],
  imports: [
    SharedModule
  ]
})
export class DealershipModule {}
